import React, { useEffect, useState, useMemo } from "react";
import SubContent from "./SubContent";
import { useNavigate, useParams } from "react-router-dom";
import { SITE_URL, toAbsoluteUrl } from "../../assets/helpers/AssetHelpers";
import "./style.css";
import MainSectionCard from "../mainsection/MainsectionCard";
import SkeletonComponent from "../SkeletonComponent";
import ParentCard from "../parentCard/parentCard";
import SubHeader from "./SubHeader";
import { Categories } from "../../types/types";
import { getCMSCategory } from "../../services/api/Api";
import MostSearchFaq from "../MostSearchFAQs/MostSearchFaq";
import Circulars from "../Circulars/Circulars";
import { setPageTitle as setDocumentTitle } from "../../utils/setPageTitle";
import JainamLoader, { loaderMessages } from "../common/JainamLoader/JainamLoader";
interface ApiResponse {
  data: {
    all_category: Categories[];
  };
}

const SubCategory = () => {
  const { category_name, child_category_name } = useParams();
  const formattedChildCategoryName = child_category_name;
  const navigate = useNavigate();

  const [data1, setData1] = useState<ApiResponse>({ data: { all_category: [] } });
  const [cmsCategoryLoading, setCmsCategoryLoading] = useState(true);
  const mainTitle = data1.data.all_category.filter((data) => data.new_id === category_name);
  const formattedMainTitle = mainTitle[0]?.category_name;
  const newTitle = data1.data.all_category.filter((data) => data.new_id === child_category_name);
  const formattedNewTitle = newTitle[0]?.category_name;
  const [pageTitle, setPageTitle] = useState<string>("Jainam Support"); // Default title

  useEffect(() => {
    if (formattedNewTitle) {
      setPageTitle(formattedNewTitle);
    }
  }, [formattedNewTitle]);

  // Set document title once pageTitle is updated
  useEffect(() => {
    if (pageTitle) {
      setDocumentTitle(pageTitle);
    }
    return () => {
      setDocumentTitle("Jainam Support");
    };
  }, [pageTitle]);

  const fetchCMSCategory = async () => {
    try {
      const response = await getCMSCategory(`site=${SITE_URL}`);
      setData1(response);
    } catch (error) {
      console.log("FetchCms Category Error");
    } finally {
      setCmsCategoryLoading(false);
    }
  };

  useEffect(() => {
    fetchCMSCategory();
  }, []);

  // Memoize the filtered data for optimization
  const filteredData = useMemo(() => {
    return data1?.data?.all_category ?? [];
  }, [data1]);

  // Filtered data based on the parent category from params
  const mappedData = useMemo(() => {
    return filteredData?.filter(
      (filterData: any) => filterData?.parent_cms_category === formattedNewTitle,
    );
  }, [filteredData, formattedNewTitle]);

  // Nested Categories Function (Recursive)
  const getSubcategories = (
    parentCategory: Categories,
    allCategories: Categories[],
  ): Categories[] => {
    const subcategories = allCategories.filter(
      (category) => category.parent_cms_category === parentCategory.id,
    );

    return subcategories.map((subcategory) => ({
      ...subcategory,
      subcategories: getSubcategories(subcategory, allCategories),
    }));
  };

  // Generate nested categories structure
  const nestedCategories = useMemo(() => {
    return data1?.data?.all_category
      .filter(
        (category) => category.parent_cms_category === null || category.parent_cms_category === "",
      )
      .map((category) => ({
        ...category,
        subcategories: getSubcategories(category, data1?.data?.all_category),
      }));
  }, [data1]);

  function toggleNavbar(event: { currentTarget: any }) {
    const button = event.currentTarget;
    const isExpanded = button.getAttribute("aria-expanded") === "false";

    if (isExpanded) {
      button.setAttribute("data-bs-state", "closed");
    } else {
      button.setAttribute("data-bs-state", "open");
    }
  }

  if (!category_name || !child_category_name) {
    navigate("/no-results-found");
    return null;
  }

  return (
    <>
      <section>
        <div className="container">
          <div className="row">
            <div className="col mb-lg-5">
              <div className="row">
                <div className="col-lg-11 mx-auto px-4 px-md-5 px-lg-2">

                  {/* <ParentCard /> */}
                  <div className="row gx-5">
                    <div className="col-xl-4 col-12 mt-xl-2 d-none d-xl-block">
                      <div className="sidebar-sticky">
                        <div className="accordion mt-5" id="sideBarAccordian">
                          {cmsCategoryLoading ? (
                            <SkeletonComponent name={"CategoryCard"} />
                          ) : (
                            nestedCategories.map((category: Categories, index: number) => (
                              <MainSectionCard
                                key={category.id}
                                cards={category}
                                index={index}
                                activeCategoryName={formattedNewTitle}
                                activeCategoryId={child_category_name}
                              />
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                    <nav className="navbar navbar-expand-xl d-none">
                      <div className="container justify-content-start px-3 px-md-4 px-lg-3">
                        <button
                          className="navbar-toggler border-0 p-0 pe-3"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#navbarNavAltMarkup"
                          aria-controls="navbarNavAltMarkup"
                          aria-expanded="false"
                          aria-label="Toggle navigation"
                          onClick={toggleNavbar}
                        >
                          <span className="navbar-toggler-icon"></span>
                        </button>
                        <a className="navbar-brand in_reg fs-18 lh-24" href="#">
                          View all categories
                        </a>
                        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                          <div className="accordion my-4" id="sideBarAccordian">
                            {cmsCategoryLoading ? (
                              <SkeletonComponent name={"CategoryCard"} />
                            ) : (
                              nestedCategories.map((category: Categories, index: number) => (
                                <MainSectionCard
                                  key={category.id}
                                  cards={category}
                                  index={index}
                                  activeCategoryName={formattedNewTitle}
                                  activeCategoryId={child_category_name}
                                />
                              ))
                            )}
                          </div>
                        </div>
                      </div>
                    </nav>

                    <div
                      className="col-xl-8 col-12 mt-xl-3 d-xl-block d-md-block"
                    // style={{ width: "69%" }}
                    >
                      {!cmsCategoryLoading ? (
                        <div className="color3 decoration pt-2">
                          <div className="sub-header-sticky">
                            <SubHeader
                              mainCategoryName={formattedMainTitle}
                              childCategoryName={formattedNewTitle}
                            />
                          </div>
                          <h5 className="py-1 color30 ur_ebold fs-28 mb-4">{formattedNewTitle}</h5>
                          {mappedData && mappedData.length > 0 ? (
                            <div
                              className="accordion font-title mt-2 border rounded-3 overflow-hidden"
                              id="subContent"
                            >
                              {mappedData.map((item: any, index: number) => (
                                <SubContent
                                  key={item.id}
                                  filteredCategory={item}
                                  category_name={category_name}
                                  child_category_name={formattedChildCategoryName}
                                  index={index}
                                  isLast={index === mappedData.length - 1}
                                />
                              ))}
                            </div>
                          ) : (
                            <div className="border-0 text-center">
                              <img
                                src={toAbsoluteUrl("about-section/no-faq.svg")}
                                alt="no_data_found"
                              />
                              <div className="row">
                                <p className="fs-6 py-2 bw_semi col-8 mt-4 mx-auto">
                                  Looks like there are no FAQs here yet, but don’t worry—more
                                  helpful information is coming soon!
                                </p>
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <JainamLoader variant="section" messages={loaderMessages.faqs} />
                      )}
                    </div>
                    <div className="col-lg-8 col-12 mt-lg-4 d-lg-none d-md-none d-block">
                      {/* {dataLoaded ? (
                        <div className="mx-lg-2 color3 decoration p-lg-3">
                          <h5 className="py-2 color28 in_semi child-category-head fs-24 px-lg-2">
                            {formattedNewTitle}
                          </h5>
                          {mappedData && mappedData.length > 0 ? (
                            <div className="accordion font-title mt-2" id="subContent">
                              {mappedData.map((item: any, index: number) => (
                                <SubContent
                                  key={item.id}
                                  filteredCategory={item}
                                  category_name={category_name}
                                  child_category_name={child_category_name}
                                  index={index}
                                  isLast={index === mappedData.length - 1}
                                />
                              ))}
                            </div>
                          ) : (
                            <div className="border-0 text-center">
                              <img
                                src={toAbsoluteUrl("about-section/no-faq.svg")}
                                alt="no_data_found"
                              />
                              <p className="fs-6 py-2 bw_semi mt-2">
                                Looks like there are no FAQs here yet, but don’t worry—more helpful
                                information is coming soon!
                              </p>
                            </div>
                          )}
                        </div>
                      ) : (
                        <JainamLoader variant="section" messages={loaderMessages.faqs} />
                      )} */}
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col-12 col-xl-6">
                      <MostSearchFaq />
                    </div>
                    <div className="col-12 col-xl-6">
                        <Circulars />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <AboutSection /> */}
      </section>
    </>
  );
};

export default SubCategory;
